import api from "./axios";

const API_URL = "/admin";

// =============================================================================
// MICRO-CREDENTIALS MANAGEMENT
// =============================================================================

export const getAllMicroCredentials = () => api.get(`${API_URL}/micro-credentials`);

export const getMicroCredentialWithStats = (credentialId) =>
  api.get(`${API_URL}/micro-credentials/${credentialId}`);

export const createMicroCredential = (data) => api.post(`${API_URL}/micro-credentials`, data);

export const updateMicroCredential = (credentialId, data) =>
  api.patch(`${API_URL}/micro-credentials/${credentialId}`, data);

export const deleteMicroCredential = (credentialId) =>
  api.delete(`${API_URL}/micro-credentials/${credentialId}`);

// Die Discord-Server, auf denen der Bot ist -- reduziert auf id und name
// (18.09.). Liegt unter /bot, nicht unter /admin: der Proxy zum Bot samt
// Fehleruebersetzung wohnt dort, und ein zweiter Proxy waere eine zweite
// Stelle fuer dieselbe Uebersetzung. Admin-only.
export const getDiscordGuilds = () => api.get("/bot/guilds");

// Die Server, die das System kennt -- auch ohne Bot (01.10.): Historie,
// Credentials, guild_id der Nachrichten. Antwort
// { server: [{ guild_id, guild_name, nachrichten }] }, IDs als Zeichenkette.
// Der Serverwechsel selbst ist der PATCH oben (updateMicroCredential).
export const getBekannteServer = () => api.get(`${API_URL}/bekannte-server`);

// =============================================================================
// USER-CREDENTIAL ASSIGNMENT
// =============================================================================

export const getAllUsers = (params = {}) => api.get(`${API_URL}/users`, { params });

export const createAdminUser = (user) => api.post(`${API_URL}/users`, user);

export const getAdminUser = (userId) => api.get(`${API_URL}/users/${userId}`);

export const updateAdminUser = (userId, user) =>
  api.put(`${API_URL}/users/${userId}`, user);

export const deleteAdminUser = (userId) =>
  api.delete(`${API_URL}/users/${userId}`);

export const assignUserToCredential = (userId, microCredentialId) =>
  api.patch(`${API_URL}/users/${userId}/assign-credential`, {
    micro_credential_id: microCredentialId,
  });

export const getAllProfessors = (params = {}) => api.get(`${API_URL}/professors`, { params });

// =============================================================================
// MULTI-CREDENTIAL ASSIGNMENT
// =============================================================================

export const assignMultipleCredentialsToUser = (userId, credentialIds, primaryCredentialId = null) =>
  api.post(`${API_URL}/users/${userId}/credentials`, {
    micro_credential_ids: credentialIds,
    primary_credential_id: primaryCredentialId,
  });

export const getUserCredentials = (userId) => api.get(`${API_URL}/users/${userId}/credentials`);

export const removeCredentialFromUser = (userId, credentialId) =>
  api.delete(`${API_URL}/users/${userId}/credentials/${credentialId}`);

export const setPrimaryCredential = (userId, credentialId) =>
  api.patch(`${API_URL}/users/${userId}/credentials/${credentialId}/primary`);

// =============================================================================
// USER TYPE MANAGEMENT
// =============================================================================

export const updateUserType = (userId, userTypeName) =>
  api.patch(`${API_URL}/users/${userId}/update-type`, {
    user_type_name: userTypeName,
  });

// =============================================================================
// DATA DUPLICATION
// =============================================================================

export const duplicateCriteria = (sourceCredentialId, targetCredentialIds, criterionIds = null) =>
  api.post(`${API_URL}/duplicate/criteria`, {
    source_credential_id: sourceCredentialId,
    target_credential_ids: targetCredentialIds,
    criterion_ids: criterionIds,
  });

export const getCriteriaForCredential = (credentialId) =>
  api.get(`${API_URL}/micro-credentials/${credentialId}/criteria`);

export const duplicateRoles = (sourceCredentialId, targetCredentialIds, roleIds = null) =>
  api.post(`${API_URL}/duplicate/roles`, {
    source_credential_id: sourceCredentialId,
    target_credential_ids: targetCredentialIds,
    role_ids: roleIds,
  });

export const getRolesForCredential = (credentialId) =>
  api.get(`${API_URL}/micro-credentials/${credentialId}/roles`);

export const duplicateTeams = (sourceCredentialId, targetCredentialIds, teamIds = null) =>
  api.post(`${API_URL}/duplicate/teams`, {
    source_credential_id: sourceCredentialId,
    target_credential_ids: targetCredentialIds,
    team_ids: teamIds,
  });

export const getTeamsForCredential = (credentialId) =>
  api.get(`${API_URL}/micro-credentials/${credentialId}/teams`);
